import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/admin/_admin/chat/conversation/$conversationId'
)({
  loader: ({ context: { auth } }) => {
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/'
      });
    }
  }
});
